import * as types from '@/store/types'

export default {

	[types.MUTATE_AIR]: (state, payload) => {	
		state.data = payload
    }     
}


// WEBPACK FOOTER //
// ./src/store/modules/air/mutations.js